import { createJSONStorage } from "zustand/middleware";
import { getSafeLocalStorage } from "@/betby/adapters/storage/storageAdapter";
import {
  getAppConfig,
  type AppConfig,
} from "@/betby/infrastructure/config/appConfig";

type PersistStorageKey = keyof AppConfig["storage"]["keys"];

export const PERSIST_STORAGE_NAMES = {
  nav: "nav-storage",
  auth: "auth-storage",
  theme: "theme-storage",
} as const;

export function createAppConfigPersistStorage<T>(
  storageKey: PersistStorageKey,
) {
  return createJSONStorage<T>(() => ({
    getItem() {
      return getSafeLocalStorage().getItem(
        getAppConfig().storage.keys[storageKey],
      );
    },
    setItem(_name, value) {
      getSafeLocalStorage().setItem(
        getAppConfig().storage.keys[storageKey],
        value,
      );
    },
    removeItem() {
      getSafeLocalStorage().removeItem(getAppConfig().storage.keys[storageKey]);
    },
  }));
}
